import { render, staticRenderFns } from "./NewsSummary.vue?vue&type=template&id=23c90cd6&"
import script from "./NewsSummary.vue?vue&type=script&lang=js&"
export * from "./NewsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports